import request from "@/utils/request";
import {baseURL} from "@/utils/getawayModule";

/***
 * 新增菜单 Post
 * @param data 新增的数据
 * @return request
 *
 * */
export function addMenu(data) {
    return request({
        url: `${baseURL.userApi}/menus`,
        method: 'post',
        data: data
    })
}

/***
 * 查询菜单列表 Get
 * @param query 查询的参数
 * @return request
 *
 * */
export function listMenu(query) {
    return request({
        url: `${baseURL.userApi}/menus/selectAllMenu`,
        method: 'get',
        params: query
    })
}

export function treeMenu(query) {
    return request({
        url: `${baseURL.userApi}/menus/selectTreeMenu`,
        method: 'get',
        params: query
    })
}

/***
 * 根据菜单名字搜索菜单 Get
 * @param query 查询的查询
 * @return request
 *
 * */
export function selectAllMenu(query) {
    return request({
        url: `${baseURL.userApi}/menus/selectMenuByName`,
        method: 'get',
        params: query
    })
}

/***
 * 根据id查询菜单 Get
 * @param query 查询的查询
 * @return request
 *
 * */
export function selectMenuById(query) {
    return request({
        url: `${baseURL.userApi}/menus/get/${query}`,
        method: 'get'
    })
}

/***
 * 修改菜单 Post
 * @param id 要修改的菜单id
 * @param data 修改的数据
 * @return request
 *
 * */
export function updateMenu(id, data) {
    return request({
        url: `${baseURL.userApi}/menus/${id}`,
        method: 'post',
        data: data
    })
}

/***
 * 根据id删除菜单  delete
 * @param id 要修改的菜单id
 * @return request
 *
 * */
export function deleteMenu(id) {
    return request({
        url: `${baseURL.userApi}/menus/${id}`,
        method: 'delete'
    })
}
